<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'column',
  created () {

  }
}
</script>



// WEBPACK FOOTER //
// Column.vue?1a5f4382